import { getFormattedDate } from '@/shared/utils'

type Props = {
  value: string
  row: {
    lastComment?: {
      date: string
      commentText: string
    } | null
    type: string
  }
}
export const CommentCell = ({ value, row }: Props) => {
  return (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.2',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {value ||
        (row?.lastComment &&
          `${getFormattedDate(row?.lastComment?.date)}: ${row?.lastComment?.commentText}`) ||
        '-'}
    </div>
  )
}
